"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFormQuestionConfigBase = void 0;
function createFormQuestionConfigBase(o = {}) {
    var _a;
    return Object.assign(Object.assign({ scoring: false, enableNA: false }, (o || {})), { richInfo: Object.assign(Object.assign({}, ((o === null || o === void 0 ? void 0 : o.richInfo) || {})), { html: '', quillDeltaStr: '', files: [...(((_a = o === null || o === void 0 ? void 0 : o.richInfo) === null || _a === void 0 ? void 0 : _a.files) || [])], fileUrls: [] }) });
}
exports.createFormQuestionConfigBase = createFormQuestionConfigBase;
exports.default = createFormQuestionConfigBase;
